/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */
import React from 'react';

import { type AvatarIconProps } from './types';

export const SocialMediaScribeAvatar = ({
	size,
	primaryColor,
	secondaryColor,
}: AvatarIconProps) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 42 48"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z"
			fill={primaryColor}
		/>
		<mask
			id="mask0_7095_36095"
			style={{ maskType: 'alpha' }}
			maskUnits="userSpaceOnUse"
			x="0"
			y="0"
			width="42"
			height="48"
		>
			<path
				d="M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z"
				fill={primaryColor}
			/>
		</mask>
		<g mask="url(#mask0_7095_36095)">
			<path
				d="M48.6709 34.1188C42.9117 36.4894 35.3817 38.733 29.4937 35.0081C32.969 32.6026 35.7299 28.9433 37.9132 25.4171L37.7643 25.6035C41.4508 20.1473 42.8835 8.15902 33.8403 7.81275C38.3076 -5.34542 33.8665 -13.1067 22.493 -0.886975C14.3654 8.61183 7.40888 22.2781 7.84353 35.1781C-8.66328 40.8598 -0.618129 15.5433 1.67387 8.36391C1.35794 8.68149 0.943409 10.0768 0.367895 11.593L0.472513 11.005C-1.30635 16.8485 -3.3307 22.8272 -2.9544 28.8429C-2.92623 29.0785 -2.8699 29.4699 -2.84374 29.3654C-2.59622 29.6235 -2.4634 31.5741 -2.22796 32.0125C-1.82148 36.9341 3.9538 37.7209 7.94014 35.9158C9.92023 47.5905 23.2094 39.5997 28.7935 35.506C33.6069 38.7699 39.9758 38.1593 45.1615 36.1227C46.1676 35.801 50.168 33.7398 48.6669 34.1168L48.6709 34.1188ZM8.74506 32.029C8.81549 30.6582 8.99457 29.3059 9.23604 27.9864L9.20585 28.0909V28.0417C8.79937 29.7731 8.42108 32.7748 8.61627 34.8749C8.55389 34.9015 8.48948 34.9282 8.42509 34.9528C7.90994 28.8142 10.1577 22.6859 12.3873 17.0821L12.4537 17.1702C11.4918 19.467 10.5621 22.2433 10.0913 24.2021C12.0452 17.4201 15.9148 9.28182 20.5572 3.1453C23.7326 -1.37872 35.0819 -12.783 34.5828 -0.23747C34.6915 -0.923859 34.4561 -3.76981 34.1643 -4.7451C35.098 -2.14092 34.7941 0.920172 34.3394 3.57967C34.2025 3.43215 34.5305 1.88726 34.5004 1.69671C34.4923 2.03069 33.8886 5.46264 32.9609 7.82709C24.6723 8.0115 20.8993 17.4488 22.2656 24.5893C18.4221 28.6585 13.9408 32.5105 8.78328 34.8012C8.69876 33.8812 8.69475 32.9489 8.74103 32.029H8.74506ZM23.155 18.3647C23.155 18.3647 23.2074 18.4753 23.2074 18.4794C24.2376 12.9945 27.3567 9.48262 32.639 8.69584C30.4697 14.1747 27.0971 19.2048 23.0162 23.7779C22.8411 22.1491 22.8774 20.4853 23.143 18.8441C23.0665 18.9548 23.0625 18.6372 23.155 18.3647ZM22.324 38.3704C17.6032 41.1753 9.66868 43.3738 8.87382 35.5367C13.8723 33.1518 17.6333 30.1521 21.2937 26.6095C21.2192 26.6976 20.7483 27.257 20.688 27.3287C20.8892 27.175 21.5533 26.5522 22.4487 25.6056C23.1752 29.1851 25.0124 32.6047 27.89 34.8483C26.093 36.1248 24.2417 37.3234 22.324 38.3704ZM28.5621 34.3627C25.5839 32.1027 23.7688 28.5499 23.155 24.8413C26.5719 21.2352 30.3832 15.2852 32.2687 11.2221C32.1922 11.5356 32.0292 11.8778 31.82 12.3818C32.4196 11.2324 32.9911 10.0112 33.5023 8.71427C36.7058 8.44176 39.3379 11.1853 39.5693 14.359C40.3883 21.6143 34.1884 30.3017 28.5621 34.3627Z"
				fill={secondaryColor}
			/>
		</g>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M28.4419 16.5931H10.5306V34.5H28.4375V16.5931H28.4419ZM14.3719 22.3506H24.605V20.43H14.3719V22.3506ZM14.3719 26.5069H24.605V24.5863H14.3719V26.5069ZM20.7681 30.6631H14.3719V28.7425H20.7681V30.6631Z"
			fill="white"
		/>
		<path
			d="M24.9156 22.9018L21 24L22.0981 20.0843L31.8631 10.3193L34.6806 13.1368L24.9156 22.9018Z"
			fill="#101214"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M25.5894 16.5931L22.0981 20.0844L22.0019 20.43H24.605V22.3506H21.4638L21 24L24.9156 22.9019L28.4419 19.3756V16.5931H25.5894Z"
			fill={primaryColor}
		/>
	</svg>
);
